
import {Component, Prop, Vue} from "vue-property-decorator";
import SvgIcon from "@jamescoyle/vue-icon";
import {mdiPlus} from "@mdi/js";

@Component({
  components: {
    SvgIcon,
  },
})

export default class RelayCreateOrEditBox extends Vue {
  @Prop({default: false})
  public display: boolean;
  @Prop()
  public buildingId: number;
  private tags: any[] | null = null;
  private addRowNumber: number = 1;
  private mdiPlus = mdiPlus;
  private rows = [];
  private loading: boolean = false;
  private headers = [
    {text: this.$t("relayCreateMultiBox.boxName") + " *", value: "name"},
    {text: this.$t("relayCreateMultiBox.sheets"), value: "sheets"},
    {text: this.$t("relayCreateMultiBox.columns"), value: "columns"},
    {text: this.$t("relayCreateMultiBox.lines"), value: "lines"},
    {text: this.$t("relayCreateMultiBox.createQrBox"), value: "Create QR Code for Box"},
    {text: this.$t("relayCreateMultiBox.tags"), value: "tags"},
  ];
  private nameRules = [
    (v) => !!v || this.$t("relayCreateMultiBox.formRules.name"),
  ];

  /**
   * GETTER
   */
  get lang(): string {
    return this.$root.$i18n.locale;
  }

  get isFormValid() {
    return this.rows.every((item) => this.nameRules.every((rule) => rule(item.name) === true));
  }

  /**
   * LIFE CYCLE
   */
  private mounted(): void {
    this.addRow();
  }

  /**
   * FUNCTION GET
   */
  private getTags(): void {
    if (!this.tags) {
      this.$store.dispatch("tags/getAll", {})
        .then((res) => {
          this.tags = res;
        });
    }
  }

  /**
   * EVENT
   */
  private addRow() {
    for (let i = 0; i < this.addRowNumber; i++) {
      const template = {name: "", sheets: 0, columns: 0, lines: 0, createQrCodeBox: false, tags: []};
      if (this.rows && this.rows.length > 0) {
        const lastRow = this.rows[this.rows.length - 1];
        template.name = lastRow.name;
        template.columns = lastRow.columns;
        template.sheets = lastRow.sheets;
        template.lines = lastRow.lines;
        template.createQrCodeBox = lastRow.createQrCodeBox;
        template.tags = JSON.parse(JSON.stringify(this.rows[this.rows.length - 1].tags));
      }
      this.rows.push(template);
    }
  }

  private submit() {
    if (!this.loading) {
      this.loading = true;
      this.$store.dispatch("buildings/addBoxes", {
        buildingId: this.buildingId,
        boxes: this.rows,
      })
        .then(() => {
          this.$store.commit("alerts/displaySuccess", {
            msg: this.$i18n?.t("actions.created"),
          });
          this.close({updateBoxes: true});
        })
        .catch((error) => {
          this.$store.commit("alerts/displayHttpError", {error});
        })
        .finally(() => {
          this.loading = false;
        });

    }
  }

  private close(closeObject) {
    this.rows = [];
    this.addRow();
    this.$emit("close", closeObject);
  }

}
